import { render, staticRenderFns } from "./Inbound.vue?vue&type=template&id=d8d7731a&"
import script from "./Inbound.vue?vue&type=script&lang=js&"
export * from "./Inbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports